/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Tabs_ShowcaseInputs */

const id_profile_tabs_showcase = /** @type {(inputs: Profile_Tabs_ShowcaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etalase`)
};

const ms_profile_tabs_showcase = /** @type {(inputs: Profile_Tabs_ShowcaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pameran`)
};

const da_profile_tabs_showcase = /** @type {(inputs: Profile_Tabs_ShowcaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Showcase`)
};

const de_profile_tabs_showcase = /** @type {(inputs: Profile_Tabs_ShowcaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitrine`)
};

const en_us2_profile_tabs_showcase = /** @type {(inputs: Profile_Tabs_ShowcaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Showcase`)
};

const es_es2_profile_tabs_showcase = /** @type {(inputs: Profile_Tabs_ShowcaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitrina`)
};

const es_mx2_profile_tabs_showcase = /** @type {(inputs: Profile_Tabs_ShowcaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitrina`)
};

const fil_profile_tabs_showcase = /** @type {(inputs: Profile_Tabs_ShowcaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Showcase`)
};

const fr_profile_tabs_showcase = /** @type {(inputs: Profile_Tabs_ShowcaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitrine`)
};

const it_profile_tabs_showcase = /** @type {(inputs: Profile_Tabs_ShowcaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vetrina`)
};

const hu_profile_tabs_showcase = /** @type {(inputs: Profile_Tabs_ShowcaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirakat`)
};

const nl_profile_tabs_showcase = /** @type {(inputs: Profile_Tabs_ShowcaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitrine`)
};

const no_profile_tabs_showcase = /** @type {(inputs: Profile_Tabs_ShowcaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ustillingsvindu`)
};

const pl_profile_tabs_showcase = /** @type {(inputs: Profile_Tabs_ShowcaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezentacja`)
};

const pt_br2_profile_tabs_showcase = /** @type {(inputs: Profile_Tabs_ShowcaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitrine`)
};

const pt_profile_tabs_showcase = /** @type {(inputs: Profile_Tabs_ShowcaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitrine`)
};

const ro_profile_tabs_showcase = /** @type {(inputs: Profile_Tabs_ShowcaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitrină`)
};

const fi_profile_tabs_showcase = /** @type {(inputs: Profile_Tabs_ShowcaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esittely`)
};

const sv_profile_tabs_showcase = /** @type {(inputs: Profile_Tabs_ShowcaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skyltfönster`)
};

const vi_profile_tabs_showcase = /** @type {(inputs: Profile_Tabs_ShowcaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trưng bày`)
};

const tr_profile_tabs_showcase = /** @type {(inputs: Profile_Tabs_ShowcaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitrin`)
};

const cs_profile_tabs_showcase = /** @type {(inputs: Profile_Tabs_ShowcaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitrína`)
};

const bg_profile_tabs_showcase = /** @type {(inputs: Profile_Tabs_ShowcaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Витрина`)
};

const ru_profile_tabs_showcase = /** @type {(inputs: Profile_Tabs_ShowcaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Витрина`)
};

const uk_profile_tabs_showcase = /** @type {(inputs: Profile_Tabs_ShowcaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вітрина`)
};

const ar_profile_tabs_showcase = /** @type {(inputs: Profile_Tabs_ShowcaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض`)
};

const hi_profile_tabs_showcase = /** @type {(inputs: Profile_Tabs_ShowcaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शोकेस`)
};

const th_profile_tabs_showcase = /** @type {(inputs: Profile_Tabs_ShowcaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โชว์เคส`)
};

const ja_profile_tabs_showcase = /** @type {(inputs: Profile_Tabs_ShowcaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショーケース`)
};

const zh_cn2_profile_tabs_showcase = /** @type {(inputs: Profile_Tabs_ShowcaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`展示柜`)
};

const zh_hant1_profile_tabs_showcase = /** @type {(inputs: Profile_Tabs_ShowcaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`展示櫃`)
};

const ko_profile_tabs_showcase = /** @type {(inputs: Profile_Tabs_ShowcaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`쇼케이스`)
};

/**
* | output |
* | --- |
* | "Showcase" |
*
* @param {Profile_Tabs_ShowcaseInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_tabs_showcase = /** @type {((inputs?: Profile_Tabs_ShowcaseInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Tabs_ShowcaseInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_tabs_showcase(inputs)
	if (locale === "ms") return ms_profile_tabs_showcase(inputs)
	if (locale === "da") return da_profile_tabs_showcase(inputs)
	if (locale === "de") return de_profile_tabs_showcase(inputs)
	if (locale === "en-US") return en_us2_profile_tabs_showcase(inputs)
	if (locale === "es-ES") return es_es2_profile_tabs_showcase(inputs)
	if (locale === "es-MX") return es_mx2_profile_tabs_showcase(inputs)
	if (locale === "fil") return fil_profile_tabs_showcase(inputs)
	if (locale === "fr") return fr_profile_tabs_showcase(inputs)
	if (locale === "it") return it_profile_tabs_showcase(inputs)
	if (locale === "hu") return hu_profile_tabs_showcase(inputs)
	if (locale === "nl") return nl_profile_tabs_showcase(inputs)
	if (locale === "no") return no_profile_tabs_showcase(inputs)
	if (locale === "pl") return pl_profile_tabs_showcase(inputs)
	if (locale === "pt-BR") return pt_br2_profile_tabs_showcase(inputs)
	if (locale === "pt") return pt_profile_tabs_showcase(inputs)
	if (locale === "ro") return ro_profile_tabs_showcase(inputs)
	if (locale === "fi") return fi_profile_tabs_showcase(inputs)
	if (locale === "sv") return sv_profile_tabs_showcase(inputs)
	if (locale === "vi") return vi_profile_tabs_showcase(inputs)
	if (locale === "tr") return tr_profile_tabs_showcase(inputs)
	if (locale === "cs") return cs_profile_tabs_showcase(inputs)
	if (locale === "bg") return bg_profile_tabs_showcase(inputs)
	if (locale === "ru") return ru_profile_tabs_showcase(inputs)
	if (locale === "uk") return uk_profile_tabs_showcase(inputs)
	if (locale === "ar") return ar_profile_tabs_showcase(inputs)
	if (locale === "hi") return hi_profile_tabs_showcase(inputs)
	if (locale === "th") return th_profile_tabs_showcase(inputs)
	if (locale === "ja") return ja_profile_tabs_showcase(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_tabs_showcase(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_tabs_showcase(inputs)
	return ko_profile_tabs_showcase(inputs)
});
export { profile_tabs_showcase as "profile.tabs.showcase" }